// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"15df0d9a","449":"1709ef3a"}[chunkId] + ".chunk.css";
};